import { gql } from '@apollo/client';


export const REMOVE_RELATIONSHIP_FROM_PERSON = gql`
  mutation removeRelationshipFromPerson($input: RemoveRelationshipFromPersonInput!) {
    removeRelationshipFromPerson(input: $input) {
     errors
     target {
       id
     }
    }
  }
`


